import { KikHttpConfig, KikHttpService } from "@kikocosmeticsorg/uc-api-nest-common-fe";

import { ErrorResponse } from "~/shared/api/error-response.class";

export type HttpConfig<T = any> = KikHttpConfig<T>;

export class HttpService extends KikHttpService {
  static get errorClass() {
    return this._errorClass;
  }

  // @override
  protected static _errorClass = ErrorResponse;
  protected static _localeHeader: string = "x-locale";

  protected static _isApiCall<T>(config: KikHttpConfig<T>) {
    return config.url.startsWith(process.env.NEXT_PUBLIC_API_V2_BASE_URL!);
  }

  protected static async _preprocessRequest<T>(config: KikHttpConfig<T>): Promise<KikHttpConfig<T>> {
    if (this._isApiCall(config)) {
      config.useCredentials = !0; // Send cookie to domain
      // Add gcpsid header at FE
      config.headers = {
        ...config.headers,
        [this._localeHeader]:
          typeof location !== "undefined"
            ? `${location?.href}`.match(/\/([a-zA-Z]{2}-[a-zA-Z]{2})\//)?.[1] || "default" // the current locale
            : "server",
      };
    }

    return config;
  }
}
